/**
 * 项目信息
*/
import http from '@/request/http'
export default {
  /******   博客   *****/
  // 获取博客列表
  developmentGetList: params => http.get(`/api/juji/project/blog/get`, params),
 

 /******   项目历程/项目资讯   *****/
 projectInfoGetList: params => http.get(`/api/juji/project/info/projects`, params),// 获取列表
 projectInfoAddEdit: params => http.post(`/api/juji/project/info/save`, params),// 新增/修改
 projectInfoDelete: (params,id) => http.delete(`/api/juji/project/info/${id}`, params),//删除

}

